var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8967 21.1297L20.4767 24.7197L16.8867 28.3097L18.3067 29.7197L23.3067 24.7197L18.3067 19.7197L16.8967 21.1297ZM23.8967 21.1297L27.4767 24.7197L23.8867 28.3097L25.3067 29.7197L30.3067 24.7197L25.3067 19.7197L23.8967 21.1297Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3066 23.7197H4.30664V8.62973L15.7366 16.5397C15.904 16.6559 16.1029 16.7181 16.3066 16.7181C16.5104 16.7181 16.7092 16.6559 16.8766 16.5397L28.3066 8.62973V17.7197H30.3066V7.71973C30.3066 7.18929 30.0959 6.68059 29.7209 6.30551C29.3458 5.93044 28.8371 5.71973 28.3066 5.71973H4.30664C3.77621 5.71973 3.2675 5.93044 2.89243 6.30551C2.51735 6.68059 2.30664 7.18929 2.30664 7.71973V23.7197C2.30664 24.2502 2.51735 24.7589 2.89243 25.1339C3.2675 25.509 3.77621 25.7197 4.30664 25.7197H14.3066V23.7197ZM26.1066 7.71973L16.3066 14.4997L6.50664 7.71973H26.1066Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMail);
export default __webpack_public_path__ + "static/media/send-mail.80ba428869771855148536476190cadf.svg";
export { ForwardRef as ReactComponent };